(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nene-collection-more"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nene-collection-more')) {
  customElements.define('nene-collection-more', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a');
      this.status = this.querySelector('[role="status"]');
      this.abort = new AbortController();
      this.busy = false;
      this.label = this.link.textContent;
      this.link.addEventListener('click', event => { event.preventDefault(); this.loadMore(true); }, { signal: this.abort.signal });
      this.observer = new IntersectionObserver(entries => { if (entries[0].isIntersecting) this.loadMore(false); }, { rootMargin: '500px 0px' });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    async loadMore(manual) {
      if (this.busy || this.link.hidden) return;
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loading;
      try {
        const url = new URL(this.link.href, window.location.origin);
        if (url.origin !== window.location.origin) throw new Error('Unexpected destination');
        url.searchParams.set('section_id', this.dataset.section);
        const response = await fetch(url, { signal: this.abort.signal });
        if (!response.ok) throw new Error('Unable to load products');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incomingGrid = html.querySelector('#product-grid');
        const grid = this.closest('.collection').querySelector('#product-grid');
        if (!incomingGrid || !grid || !this.isConnected) throw new Error('Missing product grid');
        const items = Array.from(incomingGrid.children);
        if (!items.length) throw new Error('No product items');
        items.forEach(item => { item.classList.add('scroll-trigger--cancel'); grid.append(item); });
        const next = html.querySelector('nene-collection-more a');
        this.status.textContent = this.dataset.loaded.replace('[count]', String(items.length));
        if (next) this.link.href = next.href;
        else { this.link.hidden = true; this.observer.disconnect(); }
        if (manual) { const firstLink = items[0].querySelector('h3 a'); firstLink?.focus({ preventScroll: true }); }
      } catch (error) {
        if (error.name !== 'AbortError') { this.status.textContent = this.dataset.error; this.observer.disconnect(); }
      } finally { this.busy = false; this.removeAttribute('aria-busy'); }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nene-localization"] && !Shopify.designMode) return;
  try {
    function setupNeneLocales(root){
  root.querySelectorAll('.nene-locale-form').forEach(form=>{
    if(form.dataset.ready)return;
    form.dataset.ready='true';
    const market=form.querySelector('[data-nene-market]');
    const language=form.querySelector('[data-nene-language]');
    const sync=()=>{
      const european=market.value!=='US'&&market.value!=='GB';
      for(const option of language.options){option.hidden=!european&&option.value!=='en';option.disabled=!european&&option.value!=='en';}
      language.options[0].text=market.value==='GB'?'English (UK)':market.value==='US'?'English (US)':'English';
      if(!european)language.value='en';
    };
    market.addEventListener('change',sync);sync();
    form.addEventListener('submit',()=>{sync();form.querySelector('button[type="submit"]').setAttribute('aria-busy','true');});
  });
}
setupNeneLocales(document);
document.addEventListener('shopify:section:load',event=>setupNeneLocales(event.target));
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.nene-localization[open]').forEach(el=>{el.open=false;el.querySelector('summary').focus();});});
document.addEventListener('click',event=>document.querySelectorAll('.nene-localization[open]').forEach(el=>{if(!el.contains(event.target))el.open=false;}));
  } catch(e) { console.error(e); }
})();

})();
